import { mergeProps } from "solid-js";
import { DEFAULT_INTL_CONFIG } from "@formatjs/intl";
function processConfig(config) {
    return mergeProps(DEFAULT_INTL_CONFIG, {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        defaultRichTextElements: config.defaultRichTextElements,
        onError: config.onError,
        onWarn: config.onWarn,
    });
}
export default processConfig;
